// ============================================
// Application Configuration
// ============================================

const config = {
  // API Base URL - MUST be '/api' for production (Nginx proxy)
  API_URL: '/api',
  
  // Alternative: Use environment variable with fallback
  // API_URL: process.env.REACT_APP_API_URL || '/api',
  
  // App settings
  APP_NAME: 'CloudStore',
  APP_VERSION: '1.0.0',
  
  // File upload settings
  MAX_FILE_SIZE: 100 * 1024 * 1024, // 100MB
  ALLOWED_FILE_TYPES: [
    'image/*',
    'video/*',
    'audio/*',
    'application/pdf',
    'application/msword',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    'application/vnd.ms-excel',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    'text/*',
    '.zip',
    '.rar',
    '.7z'
  ]
};

export default config;
